import * as React from "react";
import styles = require("./style.less");

const ListTitle: React.StatelessComponent<{children: any}> = props => {
   return <h3 className={styles.listTitle}>{props.children}</h3>;
};

ListTitle.displayName = "ListTitle";

export default ListTitle;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/components/ListTitle/ListTitle.tsx